import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { http, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import PlatformLogo from "@/components/PlatformLogo";
import { Loader2, MailCheck, AlertTriangle } from "lucide-react";

export default function VerifyEmail() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [state, setState] = useState({ status: "loading", message: "" });

  useEffect(() => {
    if (!token) { setState({ status: "error", message: "Link non valido." }); return; }
    http.get("/public/verify-email", { params: { token } })
      .then((r) => setState({ status: "ok", message: r.data.message }))
      .catch((e) => setState({ status: "error", message: apiErr(e) }));
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="verify-email-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center space-y-4">
        <PlatformLogo size={36} dark={false} className="justify-center" testId="verify-platform-logo" />
        {state.status === "loading" && <Loader2 className="w-10 h-10 mx-auto animate-spin text-sky-600" />}
        {state.status === "ok" && <MailCheck className="w-12 h-12 mx-auto text-emerald-600" data-testid="verify-email-success" />}
        {state.status === "error" && <AlertTriangle className="w-12 h-12 mx-auto text-amber-600" data-testid="verify-email-error" />}
        <h1 className="font-heading text-2xl font-extrabold text-slate-900">
          {state.status === "ok" ? "Email confermata" : state.status === "error" ? "Conferma non riuscita" : "Verifica in corso…"}
        </h1>
        {state.message && <p className="text-sm text-slate-600" data-testid="verify-email-message">{state.message}</p>}
        {state.status !== "loading" && (
          <Button asChild className="w-full" data-testid="verify-email-login-btn"><Link to="/login">Vai al login</Link></Button>
        )}
      </div>
    </div>
  );
}
